<div class="ui-g">
  <div class="ui-g-12">
    <hr
      class="hr-text"
      [attr.data-content]="'DATA_PORTAL.CENSUS.DETAIL.EXPORT_DATA' | translate "/>
  </div>
  <div *ngIf="!(entityLevel === searchEntityLevels.WORLD)"
       class="ui-g-12 flex-container">
    <div class="ui-g-12">
      <p-radioButton
        *ngIf="!isNSO && entityLevel === searchEntityLevels.ORGANIZATION"
        name="EntityType"
        class="m-r-20"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.NSA_LABEL' | translate }}"
        [value]="searchEntityLevels.ORGANIZATION"
        [(ngModel)]="entityExportChoice">
      </p-radioButton>
      <p-radioButton
        *ngIf="!isNSO || entityLevel === searchEntityLevels.ORGANIZATION"
        name="EntityType"
        class="m-r-20"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.NSO_LABEL' | translate }}"
        [value]="searchEntityLevels.FEDERATION"
        [(ngModel)]="entityExportChoice">
      </p-radioButton>
      <p-radioButton
        *ngIf="!isNSO || this.entityLevel === searchEntityLevels.ORGANIZATION || searchEntityLevels.REGION"
        name="EntityType"
        class="m-r-20"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.REGION_LABEL' | translate }}"
        [value]="searchEntityLevels.REGION"
        [(ngModel)]="entityExportChoice">
      </p-radioButton>
      <p-radioButton
        name="EntityType"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.WORLD_LABEL' | translate }}"
        [value]="searchEntityLevels.WORLD"
        [(ngModel)]="entityExportChoice">
      </p-radioButton>
    </div>
  </div>
  <div class="ui-g-12 m-t-10 flex-container">
    <div class="ui-g-8">
      <p-radioButton
        name="YearChoice"
        class="m-r-20"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.YEAR_SINGLE_LABEL' | translate }}"
        [value]=exportTypes.SINGLE
        [(ngModel)]="yearChoiceType"
        (onClick)="rangeForm.updateValueAndValidity()">
      </p-radioButton>
      <p-radioButton
        name="YearChoice"
        class="m-r-20"
        label="{{'DATA_PORTAL.CENSUS.DETAIL.YEAR_MUTLIPLE_LABEL' | translate }}"
        [value]=exportTypes.MULTIPLE
        [(ngModel)]="yearChoiceType">
      </p-radioButton>
    </div>
  </div>
  <div class="ui-g-12 m-t-10 flex-container">
    <form
      [formGroup]="rangeForm">
      <div [class]="yearChoiceType === exportTypes.MULTIPLE ? 'ui-g-3' : 'ui-g-6'">
        <label *ngIf="yearChoiceType === exportTypes.SINGLE" for="yearFrom">{{'DATA_PORTAL.CENSUS.DETAIL.YEAR_LABEL' | translate}}</label>
        <label *ngIf="yearChoiceType === exportTypes.MULTIPLE" for="yearFrom">{{'DATA_PORTAL.CENSUS.DETAIL.YEAR_FROM_LABEL' | translate}}</label>
        <wsd-extended-input [control]="rangeForm.get('yearFrom')">
          <input
            pInputText
            id="yearFrom"
            type="number"
            formControlName="yearFrom">
        </wsd-extended-input>
      </div>
      <div class="ui-g-3" *ngIf="yearChoiceType === exportTypes.MULTIPLE">
        <label for="yearTo">{{'DATA_PORTAL.CENSUS.DETAIL.YEAR_TO_LABEL' | translate}}</label>
        <wsd-extended-input [control]="rangeForm.get('yearTo')">
          <input
            pInputText
            id="yearTo"
            type="number"
            formControlName="yearTo">
        </wsd-extended-input>
      </div>
    </form>
  </div>

  <div class="ui-g-12 flex-container">
    <div class="ui-g-3 m-t-20">
      <button
        type="button" pButton
        [label]="'DATA_PORTAL.CENSUS.DETAIL.EXPORT_DATA_XLS' | translate"
        (click)="exportXLS()">
      </button>
    </div>

    <p-blockUI [blocked]="block">
      <div class="wrapper">
        <h4>{{ 'WS_DIRECTORY.EXPORT.PLEASE_WAIT' | translate }}</h4>
        <i class="fa fa-spinner fa-spin fa-3x"></i>
      </div>
    </p-blockUI>
  </div>
</div>
